import { Menu } from "../menu/Menu";
import { WorkSpace } from "../workspace/WorkSpace";
import { Header } from "../menu/Header";
import { Box } from "@mui/material";
import { Footer } from "../menu/Footer";
import { useSelector } from "react-redux";
import { isPrivileged } from "../../util/PrivilegeUtil";
import MissingAuthorization from "../auth/MissingAuthorization";

function Shell() {
  const session = useSelector((state: any) => state.session);
  const settings = useSelector((state: any) => state.settings.internalSettings);

  function isAuthorized() {
    return (
      (session?.currentUser?.healthCareProviderHsaId &&
      isPrivileged(session?.currentUser?.privileges, "EFK.CARD", "READ")) || settings?.security === 'none'
    );
  }

  return (
    <>
      <Header />
      <Box
        sx={{ display: "flex", flexDirection: "row", marginBottom: "8.5vh" }}
      >
        {session?.urlQueryState?.embedded === "true" ? null : <Menu />}
        <Box className="shell">
          {!isAuthorized() ? <MissingAuthorization /> : <WorkSpace />}
          
        </Box>
      </Box>
      <Footer />
    </>
  );
}
export default Shell;
